import { EventHandler, Label } from '../../../../../CommonComponents'
import RequestReasonDetail from './RequestReasonDetail'
import { Tooltip } from 'client/CommonComponents';
import AttachmentLink from './AttachmentLink';
import { CONSTANTS } from "client/utils/constants";
import { formatPrice } from 'utils';
import NonStandardItemDetail from 'client/CommonComponents/NonStandardItemDetail';

const ItemDetail = (props: any) => {

  return <div className="itemDetails">
    <div className="blueLabel">Item Details</div>
    {
      props.orderByIdValue?.requests?.map((item: any, index: number) => {
        const lableValue = () => {
          if (props.orderByIdValue?.orderType === CONSTANTS.NON_STANDARD_EQUIPMENT) {
            return "Equipment Type";
          } else {
            return "Request Type";
          }
        }
        const itemIdVal = () => {
          if (item?.orderId != null) {
            return item?.orderId + " - " + (index + 1);
          } else {
            return "-";
          }
        };
        const getEquipmentType = () => {
          if (item?.subOrderType) {
            return item?.subOrderType
          } else {
            return "-"
          }
        }
        return (
          <div key={index} className={`${item?.orderType === CONSTANTS.NON_STANDARD_EQUIPMENT ? 'nonstandardCard' : ''} ${props?.isBulkOrder ? 'bulkorder' : ''}`}>
            <div className={`itemDetailCard ${props?.getRequestStyle(index)}`} key={index}>
              <div className={item?.orderType === "Vehicle Request" ? "detailList" : "detailList managedEquipment"}>
                <div className={item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ? 'itemId managment' : 'itemId production'}>
                  <Label data-attribute="ItemDetail_Default_Label">Order Detail ID</Label>
                  <Tooltip content={itemIdVal()} data-attribute="ItemDetail_Default_Tooltip">
                    <div>{itemIdVal() || '-'}</div>
                  </Tooltip>
                </div>
                <div className={item?.subOrderType === 'Management Vehicle' ? 'vehicle managment' : 'vehicle production'}>
                  <Label data-attribute="ItemDetail_Default_Label_2">{lableValue()}</Label>
                  {
                    item?.orderType === CONSTANTS.NON_STANDARD_EQUIPMENT || item?.orderType === CONSTANTS.MANAGED_EQUIPMENT ?
                      (<Tooltip content={item?.orderType} data-attribute="ItemDetail_Default_Tooltip_2">
                        <div>{item?.orderType || '-'}</div>
                      </Tooltip>) :
                      <Tooltip content={item?.subOrderType} data-attribute="ItemDetail_Default_Tooltip_3">
                        <div>{item?.subOrderType || '-'}</div>
                      </Tooltip>
                  }
                </div>
                {
                  item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ?
                    <div className={item?.subOrderType === 'Management Vehicle' ? 'frs-order managment' : 'frs-order production'}>
                      <Label data-attribute="ItemDetail_Default_Label_3">FRS Order #</Label>
                      <Tooltip content={item?.frsOrderNumber + ""} data-attribute="ItemDetail_Default_Tooltip_4">
                        <div>{item?.frsOrderNumber || '-'}</div>
                      </Tooltip>
                    </div> : ''
                }
                {
                  item?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE ?
                    <><div className='vechicleType'>
                      <Label data-attribute="ItemDetail_Default_Label_4">Vehicle</Label>
                      <Tooltip content={item?.vehicleType} data-attribute="ItemDetail_Default_Tooltip_5">
                        <div>{item?.vehicleType || '-'}</div>
                      </Tooltip>
                    </div>
                      <div className='frs-order'>
                        <Label data-attribute="ItemDetail_Default_Label_5">FRS Order #</Label>
                        <Tooltip content={item?.frsOrderNumber + ""} data-attribute="ItemDetail_Default_Tooltip_6">
                          <div>{item?.frsOrderNumber || '-'}</div>
                        </Tooltip>
                      </div></> : ''
                }
                {
                  item?.orderType === CONSTANTS.MANAGED_EQUIPMENT ?
                    <>
                      <div className='equipmentType'>
                        <Label data-attribute="ItemDetail_Default_Label_6">Equipment Type</Label>
                        <Tooltip content={getEquipmentType()} data-attribute="ItemDetail_Default_Tooltip_7">
                          <div>{getEquipmentType()}</div>
                        </Tooltip>
                      </div>
                    </> : null
                }
                {
                  item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ?
                    <div className='driver-title'>
                      <Label data-attribute="ItemDetail_Default_Label_7">Driver Title</Label>
                      <Tooltip content={item.driverTitle} data-attribute="ItemDetail_Default_Tooltip_8">
                        <div>{item.driverTitle || '-'}</div>
                      </Tooltip>
                    </div> : ''
                }
                {
                  item?.orderType === CONSTANTS.NON_STANDARD_EQUIPMENT ?
                    <div className="price order-total">
                      <Label data-attribute="ItemDetail_Default_Label_8">Price</Label>
                      <Tooltip content={'$' + formatPrice(item.pricePerUnit || 0, 2)} data-attribute="ItemDetail_Default_Tooltip_9">
                        <div>{'$' + formatPrice(item.pricePerUnit || 0, 2) || '-'}</div>
                      </Tooltip>
                    </div>
                    :
                    <div className="price order-total">
                      <Label data-attribute="ItemDetail_Default_Label_9">Price</Label>
                      <Tooltip content={'$' + formatPrice(item.price || 0, 2)} data-attribute="ItemDetail_Default_Tooltip_10">
                        <div>{'$' + formatPrice(item.price || 0, 2) || '-'}</div>
                      </Tooltip>
                    </div>
                }
                {
                  item?.orderType === CONSTANTS.MANAGED_EQUIPMENT ?
                    <>   <div className='frs-order managed'>
                      <Label data-attribute="ItemDetail_Default_Label_10">FRS Order #</Label>
                      <Tooltip content={item?.frsOrderNumber + ""} data-attribute="ItemDetail_Default_Tooltip_11">
                        <div>{item?.frsOrderNumber || '-'}</div>
                      </Tooltip>
                    </div>
                    </> : null
                }
                {
                  item?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE ?
                    <>
                      {
                        item?.requestSearchCriteria?.showVehicleCapacity ?
                          <div className={`vehicleSize`}>
                            <Label data-attribute="ItemDetail_Default_Label_11">Vehicle Capacity</Label>
                            <Tooltip content={item.vehicleCapacity} data-attribute="ItemDetail_Default_Tooltip_12">
                              <div>{item.vehicleCapacity || -''}</div>
                            </Tooltip>
                          </div>
                          : ''
                      }
                    </> : ''
                }
                {
                  item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ?
                    <>
                      {!props?.isBulkOrder && <div className="driver-detail">
                        <Label data-attribute="ItemDetail_Default_Label_12">Driver Details</Label>
                        <div className='driver-details-itemLevel'>
                          {item?.orderType == "Vehicle Request" ? (
                            item?.vehicleDriverDetails?.map((x: any, index: any) => (
                                                        <EventHandler onEvent={() => props?.onDriverClick(x, index)} data-attribute={`ItemDetail_${(x?.employeeName || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                                                          <div className="blueBadge" key={index}>
                                                            {x?.employeeName}
                                                          </div>
                                                        </EventHandler>                            
                            ))
                          ) : (
                            ""
                          )}
                        </div>
                      </div>}
                      <div className={`vehicle-management`}>
                        <Label data-attribute="ItemDetail_Default_Label_13">Vehicle</Label>
                        <Tooltip content={item.vehicleType} data-attribute="ItemDetail_Default_Tooltip_13">
                          <div>{item.vehicleType || '-'}</div>
                        </Tooltip>
                      </div></> : item?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE ?
                      <><div className={item?.requestSearchCriteria?.showVehicleCapacity ? 'doors truck' : 'doors van'}>
                        <Label data-attribute="ItemDetail_Default_Label_14"># of Doors</Label>
                        <Tooltip content={item.noOfDoors} data-attribute="ItemDetail_Default_Tooltip_14">
                          <div>{item.noOfDoors || '-'}</div>
                        </Tooltip>
                      </div>
                        <div className={`upfit ${item?.requestSearchCriteria?.showVehicleCapacity ? 'truck' : 'van'}`}>
                          <Label data-attribute="ItemDetail_Default_Label_15">Upfit Option</Label>
                          <Tooltip content={item.upfitOption} data-attribute="ItemDetail_Default_Tooltip_15">
                            <div>{item.upfitOption || '-'}</div>
                          </Tooltip>
                        </div></> : ''
                }
                {
                  item?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE || item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ?
                    <><div className={item?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE ? item?.requestSearchCriteria?.showVehicleCapacity ? 'drive-train mb-sm-0 truck' : 'drive-train mb-sm-0 van' : 'drive-train mb-sm-0 management'}>
                      <Label data-attribute="ItemDetail_Default_Label_16">Drive Train</Label>
                      <Tooltip content={item.driveTrain} data-attribute="ItemDetail_Default_Tooltip_16">
                        <div>{item.driveTrain || '-'}</div>
                      </Tooltip>
                    </div>
                      <div className={item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ? 'fueltype' : item?.requestSearchCriteria?.showVehicleCapacity ? 'fueltype production truck' : 'fueltype production van'}>
                        <Label data-attribute="ItemDetail_Default_Label_17">Fuel Type</Label>
                        <Tooltip content={item?.fuelType || '-'} data-attribute="ItemDetail_Default_Tooltip_17">
                          <div>{item?.fuelType || '-'}</div>
                        </Tooltip>
                      </div></> : ''
                }
                {
                  item?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE &&
                  <>
                    <div className='snow-setup-container'>
                      <Label data-attribute="ItemDetail_Default_Label_18">Snow Setup</Label>
                      <Tooltip content={item.snowSetup} data-attribute="ItemDetail_Default_Tooltip_18">
                        <div>{item.snowSetup || '-'}</div>
                      </Tooltip>
                    </div>
                  </> 
                }
                {
                  item?.orderType === CONSTANTS.MANAGED_EQUIPMENT || props?.isBulkOrder ?
                    <>
                      <div className={`descriptionType ${item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ? 'management' : 'production'}`}>
                        <Label data-attribute="ItemDetail_Default_Label_19">Description</Label>
                        <Tooltip content={item?.description || '-'} data-attribute="ItemDetail_Default_Tooltip_19">
                          <div>{item?.description || '-'}</div>
                        </Tooltip>
                      </div>
                      {
                        props?.isBulkOrder ?
                          <div className={`make-bulkorder ${item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ? 'management' : item?.requestSearchCriteria?.showVehicleCapacity ? 'truck' : 'van managed'}`}>
                            <Label data-attribute="ItemDetail_Default_Label_20">Make</Label>
                            <Tooltip content={item?.make || '-'} data-attribute="ItemDetail_Default_Tooltip_20">
                              <div>{item?.make || '-'}</div>
                            </Tooltip>
                          </div> : ''
                      }
                    </> : null
                }
                {
                  item?.orderType != CONSTANTS.MANAGED_EQUIPMENT && props?.isBulkOrder ?
                    <>
                      <div className={`model-bulkorder ${item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ? 'management' : item?.requestSearchCriteria?.showVehicleCapacity ? 'truck' : 'van'}`}>
                        <Label data-attribute="ItemDetail_Default_Label_21">Model</Label>
                        <Tooltip content={item?.model || '-'} data-attribute="ItemDetail_Default_Tooltip_21">
                          <div>{item?.model || '-'}</div>
                        </Tooltip>
                      </div>
                    </> : null
                }
                {
                  item?.orderType === "Non-Standard Equipment" ?
                    <NonStandardItemDetail item={item} isApproval  data-attribute="ItemDetail_Default_NonStandardItemDetail" /> : ''
                }
                <div className={item?.orderType === CONSTANTS.MANAGED_EQUIPMENT || item?.orderType === CONSTANTS.NON_STANDARD_EQUIPMENT ? 'managedequipattach' : item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ? 'requisition management' : 'requisition'}>
                  <AttachmentLink
                    item={item}
                    index={index}
                    itemLevel={"Request"}
                    className="mb-sm-2 mb-5"
                  />
                </div>
                {/* <div className={item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ? 'order-notes pendingOrderNotes management' : item.vehicleType === CONSTANTS.TRUCK ? 'order-notes pendingOrderNotes truck' : 'order-notes pendingOrderNotes'}>
                  <Label data-attribute="ItemDetail_Default_Label_22">Comments</Label>
                  <Tooltip content={item.comments} data-attribute="ItemDetail_Default_Tooltip_22">
                    <div>{item.comments || '-'}</div>
                  </Tooltip>
                </div> */}
                <div className={`showStatus ${item?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE ? item?.requestSearchCriteria?.showVehicleCapacity ? 'truck' : '' : ''}`}></div>
              </div>
              <div className="checkboxList">
              </div>

              <div className='request-reason-block'>
                <RequestReasonDetail
                  index={index}
                  planned={props?.requestReasonDetailData?.planned?.[index]}
                  growth={props?.requestReasonDetailData?.growth?.[index]}
                  unplanned={props?.requestReasonDetailData?.unPlanned?.[index]}
                  itemDetail={item}
                  viewType='Approval-screen'
                  isBulkOrder={props?.isBulkOrder}
                />

              </div>
            </div>
          </div>
        )
      })
    }
  </div >
}

export default ItemDetail;
